(function () {
    "use strict";

    angular.module("app").component("screeningRemark", {
        templateUrl: "@/screening/screeningRemark.component.html",
        bindings: {
            remark: "=",
            isReadOnly: "=?",
            onSet: "=?",
            onSave: "<"
        },
        controller: ScreeningRemarkController
    });

    ScreeningRemarkController.$inject = ["$rootScope", "notificationService",];
    function ScreeningRemarkController($rootScope, notificationService) {
        const $ctrl = this;

        $ctrl.codePartners = $rootScope.codePartners;

        // Lifecycle hooks
        $ctrl.$onChanges = handleOneWayBindingChanges;

        $ctrl.hasAdviceBeenGiven = () => $ctrl.remark.IsValid !== null;

        $ctrl.onSliderValueChanged = onSliderValueChanged;
        $ctrl.onTextChanged = onTextChanged;

        // Lifecycle event handlers
        function handleOneWayBindingChanges(changes) {
            if (!changes)
                return;

            if (!$ctrl.remark) {
                $ctrl.remark = {};
            }
        }

        // DOM event handlers

        function onTextChanged() {
            if ($ctrl.isReadOnly)
                return;

            if ($ctrl.remark.IsValid || $ctrl.remark.IsValid === null)
                return;

            if ($ctrl.remark.Description &&
                $ctrl.remark.Description.trim().length > 0) {
                createUpdateRemark();
            }
        }

        function onSliderValueChanged(newValue) {
            updateRemark($ctrl.remark, newValue);

            createUpdateRemark();
        }

        // Implementation        

        function createUpdateRemark() {
            if ($ctrl.isReadOnly)
                return;

            if (!$ctrl.remark || !angular.isFunction($ctrl.onSave))
                return;

            if ($ctrl.remark.IsValid === false && $ctrl.remark.Description === null)
                return;

            $ctrl.onSave(
                { Remark: $ctrl.remark },
                (result) => {
                    if (CheckResultReceived(result)) {
                        if (angular.isFunction($ctrl.onSet))
                            $ctrl.onSet(result.data);
                    }
                    else
                        DoShowError(notificationService, result);
                },
                error => DoShowError(notificationService, error)
            );
        }

        function updateRemark(remark, newValue) {
            remark.IsValid = newValue;
            if (remark.IsValid)
                remark.Description = null;
        }
    }
})();